// src/utils/csrf.js
export const CSRF_KEY = "csrf_token";

export function saveCsrfToken(token) {
  try {
    if (typeof token !== "string" || !token)
      throw new Error("csrf_token missing");
    localStorage.setItem(CSRF_KEY, token);
    return token;
  } catch (e) {
    // console.error("saveCsrfToken failed:", e);
    return null;
  }
}

// previous old
// export function saveCsrfToken(payload) {
//   try {
//     const obj = typeof payload === "string" ? JSON.parse(payload) : payload;
//     const token = obj?.data?.csrf_token;
//     if (typeof token !== "string" || !token)
//       throw new Error("csrf_token missing");
//     localStorage.setItem(CSRF_KEY, token);
//     return token;
//   } catch (e) {
//     console.error("saveCsrfToken failed:", e);
//     return null;
//   }
// }

export function getCsrfToken() {
  const t = localStorage.getItem(CSRF_KEY);
  return typeof t === "string" && t.trim() ? t : null;
}

export function deleteCsrfToken() {
  try {
    localStorage.removeItem(CSRF_KEY);
    return true;
  } catch (e) {
    console.error("deleteCsrfToken failed:", e);
    return false;
  }
}
